export default function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-background-50 rounded-2xl p-8 md:p-12 border border-background-300/30">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-50">移动观影</h2>
            <p className="text-foreground-500 text-sm mt-3 leading-relaxed max-w-md mx-auto lg:mx-0">
              桔子影院移动端完美适配手机与平板浏览器，无需下载安装任何App。打开浏览器输入网址即可享受高清流畅的观影体验，省去下载烦恼，随时随地看你想看。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-lg bg-primary-500/15 flex items-center justify-center">
                  <i className="ri-smartphone-line text-primary-400"></i>
                </div>
                <div>
                  <p className="text-foreground-100 text-xs font-semibold">手机适配</p>
                  <p className="text-foreground-600 text-[10px]">iOS / Android</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-lg bg-accent-500/15 flex items-center justify-center">
                  <i className="ri-tablet-line text-accent-400"></i>
                </div>
                <div>
                  <p className="text-foreground-100 text-xs font-semibold">平板优化</p>
                  <p className="text-foreground-600 text-[10px]">iPad / Android Pad</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-lg bg-secondary-500/15 flex items-center justify-center">
                  <i className="ri-wifi-line text-secondary-700"></i>
                </div>
                <div>
                  <p className="text-foreground-100 text-xs font-semibold">无需下载</p>
                  <p className="text-foreground-600 text-[10px]">浏览器即开即看</p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-sm">
            <div className="relative">
              <div className="absolute -inset-6 bg-primary-500/8 rounded-3xl blur-2xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-background-300/30">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20movie%20streaming%20interface%20with%20film%20posters%2C%20dark%20theme%20UI%20design%2C%20warm%20orange%20accent%20colors%2C%20cinematic%20app%20screenshot%20aesthetic%2C%20clean%20modern%20layout%2C%20phone%20held%20in%20hand%20against%20dark%20background&width=600&height=900&seq=juzi-app-mockup-01&orientation=portrait"
                  alt="桔子影院移动端观影界面展示"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}